// import CryptoJS from 'crypto-js';
var moment = require("moment");
var CryptoJS = require("crypto-js");
// local
// comment This before running  command npm run build
// const API_Link = "http://localhost/vlims/backend/public/api/";
// const API_SRC = "http://localhost/vlims/backend/public/";

// const API_Link = "http://127.0.0.1:8000/api/";
// const API_SRC = "http://127.0.0.1:8000/";

// const ValidateHeader = CryptoJS.MD5(
//   'P@ce-' + moment().format('YYYY-MM-DD') + '-T3c4'
// ).toString();

const generateAuthToken = () => {
  const currentDate = moment().format("YYYY-MM-DD");
  const authToken = CryptoJS.MD5(`P@ce-${currentDate}-T3c4`).toString();
  return authToken;
};

const ValidateHeader = generateAuthToken();
// //Live URL
// Uncomment This before running  command npm run build
// const API_Link = 'http://virolims.pacemis.com:81/api/';
// const API_SRC = 'http://virolims.pacemis.com:81/';

// Uncomment This before running  command npm run build
// const API_Link = 'https://vlimsdev.pacemis.com:85/api/';
// const API_SRC = 'https://vlimsdev.pacemis.com:85/';

//  with https do not uncomment this
const API_Link = "https://virolims.pacemis.com:85/api/";
const API_SRC = "https://virolims.pacemis.com:85";

// const API_Link = '/backend/api/';
// const API_SRC = '/backend';

export { API_Link, ValidateHeader, API_SRC, generateAuthToken };
